var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 17.9997 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.36563 12.7583L14.8535 6.27043L14.8951 6.22898L14.8989 6.22498L13.9265 5.25241L13.9202 5.24609H13.9201L13.9161 5.24215L8.36563 10.792L4.7786 7.20499L3.79574 8.1881L4.28726 8.67934L8.36563 12.7583Z",
    fill: "var(--fill-0, #FF2929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3397 0H1.66001C0.742816 0.00028125 0.00028125 0.743238 0 1.66029V16.34C0.00028125 17.2569 0.742816 17.9997 1.66001 18H16.3397C17.2569 17.9998 17.9995 17.2569 17.9997 16.34V1.66029C17.9996 0.743238 17.257 0.00028125 16.3397 0ZM1.04235 1.66029C1.04302 1.31931 1.31931 1.04316 1.66004 1.04245H16.3397C16.6807 1.04316 16.9567 1.31931 16.9574 1.66029V16.34C16.9567 16.6808 16.6808 16.9568 16.3397 16.9575H1.66001C1.31931 16.9568 1.04302 16.6808 1.04231 16.34L1.04235 1.66029Z",
    fill: "var(--fill-0, #FF2929)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.05f1bfee8d10f6c11a04e5d2fd58de44.svg";
export { ForwardRef as ReactComponent };